import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../../components/Icon';
import { EditableTextInput } from '../../../../components/Form';
import { FOLDER_NAME_MAX_LENGTH } from '../../utils/constants';
import { theme } from '../../../../styles/theme';
import { StyledNavItem } from '../../../../components/SecondaryNav/SecondaryNavUI';

interface IProps {
  value: string;
  onSubmit: (newValue: string) => void;
  onCancel?: () => void;
  allowSameValue?: boolean;
}

const Container = styled(StyledNavItem)`
  color: ${theme.colors.mainBlue};
`;

const EditableDashboardFolder = ({
  value,
  onSubmit,
  onCancel,
  allowSameValue,
}: IProps) => {
  return (
    <Container>
      <SvgIcon
        name="folder"
        width={16}
        height={16}
        customFill={theme.colors.secondary800}
      />
      <EditableTextInput
        onSubmit={onSubmit}
        onCancel={onCancel}
        value={value}
        limit={FOLDER_NAME_MAX_LENGTH}
        inputSize="S"
        allowEmpty={false}
        autoFocus={true}
        allowSameValue={allowSameValue}
      />
    </Container>
  );
};

export default EditableDashboardFolder;
